const getGoogleApi = () => window.gapi;

// Private Methods
const initClient = () => {
  return new Promise((resolve, reject) => {
    getGoogleApi().load('client:auth2', () => {
      return getGoogleApi()
        .client.init({
          apiKey: process.env.GOOGLE_DRIVE_API_KEY,
          clientId: process.env.GOOGLE_DRIVE_CLIENT_ID,
          scope: 'https://www.googleapis.com/auth/drive.file',
          discoveryDocs: [
            'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest',
          ],
        })
        .then(() => getGoogleApi().auth2.getAuthInstance().signIn())
        .then(resolve)
        .catch(reject);
    });
  });
};

// Returns the ID of the found or created folder
// This is the folder where we will store the users's Parlay Data
const findOrCreateDriveFolder = () => {
  const folderName = 'Parlay Data';
  const mimeType = 'application/vnd.google-apps.folder';
  // Search Google for the folder
  return getGoogleApi()
    .client.drive.files.list({
      // Properties (mimeType and folderName)
      // need to be quoted to be properly processed by the google client
      q: `mimeType='${mimeType}' and name='${folderName}'`,
      spaces: 'drive',
    })
    .then((results) => {
      const folders = results.result.files;
      // If the folder does not exist, create it
      if (!folders.length) {
        return getGoogleApi()
          .client.drive.files.create({
            fields: 'id',
            name: folderName,
            mimeType: mimeType,
          })
          .then((res) => {
            return res.result.id;
          });
      } else {
        // If the folder exists, return its id
        return folders[0].id;
      }
    });
};

// This way to upload a file is necessary due to the limitations of the google
// api client. This method has been cited frequently online as the only way
// to upload a file with the client. It even appears somewhere in the google
// drive api documentation for V2.
const uploadFile = (data, fileName, folderID) => {
  const boundary = '-------314159265358979323846';
  const delimiter = '\r\n--' + boundary + '\r\n';
  const close_delim = '\r\n--' + boundary + '--';

  const fileContent = data;

  const metadata = {
    name: fileName,
    // folderID that we extracted from previous call to google API
    parents: [folderID],
    mimeType: 'application/vnd.google-apps.spreadsheet\r\n\r\n',
  };

  const multipartRequestBody =
    delimiter +
    'Content-Type: application/json\r\n\r\n' +
    JSON.stringify(metadata) +
    delimiter +
    'Content-Type: ' +
    'text/csv\r\n\r\n' +
    fileContent +
    close_delim;

  return getGoogleApi().client.request({
    path: '/upload/drive/v3/files',
    method: 'POST',
    params: {
      uploadType: 'multipart',
    },
    headers: {
      'Content-Type': 'multipart/related; boundary="' + boundary + '"',
    },
    body: multipartRequestBody,
  });
};

// Exportable Public Method
const uploadCSVFileToDrive = (data, fileName) => {
  return initClient()
    .then(() => findOrCreateDriveFolder())
    .then((folderID) => uploadFile(data, fileName, folderID));
};

export default {
  uploadCSVFileToDrive,
};



// WEBPACK FOOTER //
// ./src/app/utils/googleDrive.js